const getters = {
  // selectSubject: (state) => state.filterCard.selectSubject,
  title: (state) => state.app.title,
  navHidden: (state) => state.app.navHidden,
};
export default getters;
